import { groupDetailsActionTypes } from './Constants';
import _ from 'lodash';

const initialState = {
	loading: false,
	groupDetailsLoading: false,
	groupDetails: {
		owned_group: false,
		creator: null,
		subject: null,
	},
	lists: null,
	isOpenAddListModal: false,
	addListModalLoading: false,
	members: [],
	users: [],

	inviteMembersForm: {
		inviteUserError: null,
		valid: false,
	},
	groupInviteModal: {
		open: false,
		loading: false,
		activeTabIndex: 0,
		groupId: null,
	},
	groupListMembers: null,
	groupListMemberResults: null,
	groupMemberLists: null,
	showEmptyState: false,
	groupQuestions: {},
	groupQuestionAnswers: {},

	loadingInstituteLicences: true,
	instituteLicences: [],
	inactiveLicenses: [],
};

export default function groupDetailsReducer(state = initialState, action) {
	const { type, payload } = action;
	const {
		groupDetails,
		lists,
		status,
		members,
		userId,
		groupUserId,
		message,
		fieldIndex,
		data,
		listId,
		questionId,
		results,
		activeTabIndex,
		error,
		summary,
		difficultWords,
		subject,
		inactiveLicenses,
		expiredLicenses,
		licenseId,
	} = payload || {};

	switch (type) {
		case groupDetailsActionTypes.GET_GROUP_LISTS_REQUEST:
		case groupDetailsActionTypes.GET_GROUP_MEMBERS_REQUEST:
		case groupDetailsActionTypes.DELETE_LIST_FROM_GROUP_REQUEST:
		case groupDetailsActionTypes.DELETE_USER_FROM_GROUP_REQUEST:
		case groupDetailsActionTypes.DECLINE_USER_REQUEST:
		case groupDetailsActionTypes.REVOKE_USER_INVITE_REQUEST:
		case groupDetailsActionTypes.ACCEPT_USER_REQUEST:
			return {
				...state,
				loading: true,
			};

		case groupDetailsActionTypes.GET_GROUP_DETAILS_REQUEST:
			return {
				...state,
				groupDetailsLoading: true,
			};

		case groupDetailsActionTypes.CLEAR_GROUP_DETAILS:
			return initialState;

		case groupDetailsActionTypes.GET_GROUP_DETAILS_SUCCESS:
			return {
				...state,
				groupDetailsLoading: false,
				groupDetails,
				members: [
					...state.members,
					{
						id: 1,
						status: 'is_group_owner',
						...groupDetails.creator,
					},
				],
			};

		case groupDetailsActionTypes.GET_GROUP_LISTS_SUCCESS:
			return {
				...state,
				loading: false,
				lists,
			};

		case groupDetailsActionTypes.GET_GROUP_MEMBERS_SUCCESS:
			const groupMembers = state.groupDetails.creator
				? [
						...members,
						{
							id: 1,
							status: 'is_group_owner',
							...state.groupDetails.creator,
						},
				  ]
				: members;

			return {
				...state,
				loading: false,
				members: groupMembers,
				inactiveLicenses,
				expiredLicenses,
			};

		case groupDetailsActionTypes.CLEAN_MEMBERS_STATE:
			return {
				...state,
				loading: false,
				members: [],
			};

		case groupDetailsActionTypes.DELETE_USER_FROM_GROUP_SUCCESS:
		case groupDetailsActionTypes.REVOKE_USER_INVITE_SUCCESS:
			return {
				...state,
				loading: false,
				members: state.members.filter((member) => member.id !== groupUserId),
				expiredLicenses: state.expiredLicenses?.filter(
					(member) => member.id !== groupUserId,
				),
			};

		case groupDetailsActionTypes.DECLINE_USER_SUCCESS:
			return {
				...state,
				loading: false,
				members: state.members.filter((member) => member.id !== userId),
				groupDetails: {
					...state.groupDetails,
					requested_to_join_count: state.groupDetails.requested_to_join_count - 1,
				},
			};

		case groupDetailsActionTypes.ACCEPT_USER_SUCCESS:
			return {
				...state,
				loading: false,
				members: state.members.map((member) => {
					const { id: memberId } = member || {};
					if (memberId === userId) {
						member.status = 'is_group_member_but_not_owner';
					}
					return member;
				}),
				groupDetails: {
					...state.groupDetails,
					requested_to_join_count: state.groupDetails.requested_to_join_count - 1,
				},
			};

		case groupDetailsActionTypes.GET_GROUP_DETAILS_ERROR:
		case groupDetailsActionTypes.DELETE_USER_FROM_GROUP_ERROR:
		case groupDetailsActionTypes.DECLINE_USER_ERROR:
		case groupDetailsActionTypes.REVOKE_USER_INVITE_ERROR:
		case groupDetailsActionTypes.ACCEPT_USER_ERROR:
		case groupDetailsActionTypes.GROUP_ADD_ITEMS_ERROR:
		case groupDetailsActionTypes.DELETE_LIST_FROM_GROUP_ERROR:
			return {
				...state,
				loading: false,
			};

		case groupDetailsActionTypes.GET_GROUP_LISTS_ERROR:
		case groupDetailsActionTypes.GET_GROUP_MEMBERS_ERROR:
			return {
				...state,
				loading: false,
				showEmptyState: error.response.status === 403,
			};

		case groupDetailsActionTypes.GET_GROUP_LIST_MEMBERS_ERROR:
			return {
				...state,
				groupListMembers: {
					...state.groupListMembers,
					[listId]: {
						loading: false,
						members: [],
					},
				},
			};

		case groupDetailsActionTypes.TOGGLE_GROUP_ADD_LIST_MODAL:
			return {
				...state,
				isOpenAddListModal: status,
			};

		case groupDetailsActionTypes.GROUP_ADD_ITEMS_REQUEST:
			return {
				...state,
				addListModalLoading: true,
			};

		case groupDetailsActionTypes.GROUP_ADD_ITEMS_SUCCESS:
			return {
				...state,
				addListModalLoading: false,
				isOpenAddListModal: false,
			};

		case groupDetailsActionTypes.CHECK_IF_USER_EXIST_ERROR:
			return {
				...state,
				inviteMembersForm: {
					...state.inviteMembersForm,
					inviteUserError: {
						fieldIndex,
						message,
					},
				},
			};

		case groupDetailsActionTypes.SET_VALID_INVITE_MEMBERS:
			return {
				...state,
				inviteMembersForm: {
					...state.inviteMembersForm,
					valid: status,
				},
			};

		case groupDetailsActionTypes.TOGGLE_GROUP_INVITE_MODAL:
			return {
				...state,
				groupInviteModal: {
					...data,
					activeTabIndex,
					loading: false,
				},
				inviteMembersForm: {
					inviteUserError: null,
					valid: false,
				},
			};

		case groupDetailsActionTypes.INVITE_USERS_REQUEST:
			return {
				...state,
				groupInviteModal: {
					...state.groupInviteModal,
					loading: true,
				},
			};

		case groupDetailsActionTypes.INVITE_USERS_SUCCESS:
			return {
				...state,
				groupInviteModal: {
					...state.groupInviteModal,
					loading: false,
					open: false,
				},
			};

		case groupDetailsActionTypes.INVITE_USERS_ERROR:
			return {
				...state,
				groupInviteModal: {
					...state.groupInviteModal,
					loading: false,
				},
			};

		case groupDetailsActionTypes.CLEAR_INVITE_USERS_FORM:
			return {
				...state,
				inviteMembersForm: {
					inviteUserError: null,
					valid: false,
				},
			};

		case groupDetailsActionTypes.GET_GROUP_LIST_MEMBERS_REQUEST:
			return {
				...state,
				groupListMembers: {
					...state.groupListMembers,
					[listId]: {
						loading: true,
						members: [],
					},
				},
			};

		case groupDetailsActionTypes.GET_GROUP_LIST_MEMBERS_SUCCESS:
			return {
				...state,
				groupListMembers: {
					...state.groupListMembers,
					[listId]: {
						loading: false,
						members,
						summary,
					},
				},
			};

		case groupDetailsActionTypes.GET_GROUP_LIST_RESULTS_REQUEST:
			return {
				...state,
				groupListMemberResults: {
					...state.groupListMemberResults,
					[listId + userId]: {
						loading: true,
						results: [],
					},
				},
			};

		case groupDetailsActionTypes.GET_GROUP_LIST_RESULTS_SUCCESS:
			return {
				...state,
				groupListMemberResults: {
					...state.groupListMemberResults,
					[listId + userId]: {
						loading: false,
						results,
					},
				},
			};

		case groupDetailsActionTypes.GET_GROUP_LIST_RESULTS_ERROR:
			return {
				...state,
				groupListMemberResults: {
					...state.groupListMemberResults,
					[listId + userId]: {
						loading: false,
						results: [],
					},
				},
			};

		case groupDetailsActionTypes.GET_GROUP_MEMBER_LISTS_REQUEST:
			return {
				...state,
				groupMemberLists: {
					...state.groupMemberLists,
					[userId]: {
						loading: true,
						lists: [],
					},
				},
			};

		case groupDetailsActionTypes.GET_GROUP_MEMBER_LISTS_SUCCESS:
			const activeLists = lists.filter((list) => list.results_count !== 0);
			const sortedByLastPractised = _(activeLists)
				.orderBy((item) => item.last_practiced_timestamp, 'desc')
				.value();

			return {
				...state,
				groupMemberLists: {
					...state.groupMemberLists,
					[userId]: {
						loading: false,
						lists: sortedByLastPractised,
						summary,
					},
				},
			};

		case groupDetailsActionTypes.GET_GROUP_MEMBER_LISTS_ERROR:
			return {
				...state,
				groupMemberLists: {
					...state.groupMemberLists,
					[userId]: {
						loading: false,
						lists: [],
					},
				},
			};

		case groupDetailsActionTypes.GET_DIFFICULT_WORDS_REQUEST:
			return {
				...state,
				groupListMembers: {
					...state.groupListMembers,
					[listId]: {
						...state.groupListMembers[listId],
						difficult_words_loading: true,
						difficultWords: [],
						subject: [],
					},
				},
			};

		case groupDetailsActionTypes.GET_DIFFICULT_WORDS_SUCCESS:
			return {
				...state,
				groupListMembers: {
					...state.groupListMembers,
					[listId]: {
						...state.groupListMembers[listId],
						difficult_words_loading: false,
						difficultWords,
						subject,
					},
				},
			};

		case groupDetailsActionTypes.GET_DIFFICULT_WORDS_ERROR:
			return {
				...state,
				groupListMembers: {
					...state.groupListMembers,
					[listId]: {
						...state.groupListMembers[listId],
						difficult_words_loading: false,
						difficultWords: [],
						subject: [],
					},
				},
			};

		case groupDetailsActionTypes.GET_GROUP_QUESTIONS:
			return {
				...state,
				groupQuestions: {
					...state.groupQuestions,
					[listId]: {
						...state.groupQuestions[listId],
						loading: true,
						questions: [],
					},
				},
			};
		case groupDetailsActionTypes.GET_GROUP_QUESTIONS_SUCCESS:
			return {
				...state,
				groupQuestions: {
					...state.groupQuestions,
					[listId]: {
						...state.groupQuestions[listId],
						loading: false,
						questions: data,
					},
				},
			};
		case groupDetailsActionTypes.GET_GROUP_QUESTIONS_ERROR:
			return {
				...state,
				groupQuestions: {
					...state.groupQuestions,
					[listId]: {
						...state.groupQuestions[listId],
						loading: false,
						questions: [],
					},
				},
			};

		case groupDetailsActionTypes.GET_GROUP_QUESTION_ANSWERS:
			return {
				...state,
				groupQuestionAnswers: {
					...state.groupQuestionAnswers,
					[questionId]: {
						loading: true,
					},
				},
			};
		case groupDetailsActionTypes.GET_GROUP_QUESTION_ANSWERS_SUCCESS:
			return {
				...state,
				groupQuestionAnswers: {
					...state.groupQuestionAnswers,
					[questionId]: {
						...data,
						loading: false,
					},
				},
			};
		case groupDetailsActionTypes.GET_GROUP_QUESTION_ANSWERS_ERROR:
			return {
				...state,
				groupQuestionAnswers: {
					...state.groupQuestionAnswers,
					[questionId]: {
						loading: false,
					},
				},
			};

		case groupDetailsActionTypes.GET_INSTITUTE_LICENCES:
			return {
				...state,
				loadingInstituteLicences: true,
			};
		case groupDetailsActionTypes.GET_INSTITUTE_LICENCES_SUCCESS:
			return {
				...state,
				instituteLicences: data,
				loadingInstituteLicences: false,
			};
		case groupDetailsActionTypes.GET_INSTITUTE_LICENCES_ERROR:
			return {
				...state,
				loadingInstituteLicences: false,
			};
		case groupDetailsActionTypes.ADD_LICENCES_TO_GROUP:
			return {
				...state,
				loading: true,
			};
		case groupDetailsActionTypes.ADD_LICENCES_TO_GROUP_FINAL:
			return {
				...state,
				loading: false,
			};
		case groupDetailsActionTypes.REMOVE_INACTIVE_LICENSE_SUCCESS:
			return {
				...state,
				inactiveLicenses: state.inactiveLicenses.filter(
					(licence) => licence.id !== licenseId,
				),
			};

		default:
			return state;
	}
}
